/**
 * Created by jerome on 13/10/2018.
 */
const addProperty = function (obj, propname, setter, getter) {
  Object.defineProperty(obj, propname, {get: getter, set: setter})
}
export default addProperty